import { search } from './sha256'

/**
 * 解注册前的工作量证明（D95）：找 nonce 使 sha256("{salt}:{nonce}") 前 difficulty 位为 0。
 *
 * 有 Worker 就在后台线程里算；没有（测试环境、极老的浏览器）就在主线程里分批算，每批之间让出一次。
 */
export function solvePow(salt: string, difficulty: number): Promise<string> {
  if (typeof Worker !== 'undefined') {
    try {
      const worker = new Worker(new URL('./pow.worker.ts', import.meta.url), { type: 'module' })
      return new Promise((resolve, reject) => {
        worker.onmessage = (event: MessageEvent<{ nonce: string }>) => {
          worker.terminate()
          resolve(event.data.nonce)
        }
        worker.onerror = (error) => {
          worker.terminate()
          reject(error)
        }
        worker.postMessage({ salt, difficulty })
      })
    } catch {
      /* 建不了 Worker（比如 CSP），退回主线程 */
    }
  }
  return solveInline(salt, difficulty)
}

async function solveInline(salt: string, difficulty: number): Promise<string> {
  const batch = 20_000
  for (let start = 0; ; start += batch) {
    const found = search(salt, difficulty, start, batch)
    if (found !== null) return String(found)
    await new Promise((resolve) => setTimeout(resolve, 0))
  }
}
